import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Generated1784536714 from "./generated/Generated1784536714";
import Generated1784537122 from "./generated/Generated1784537122";
import Generated1784537459 from "./generated/Generated1784537459";
import Generated1784537902 from "./generated/Generated1784537902";
import Generated1784538152 from "./generated/Generated1784538152";
import Generated1784540504 from "./generated/Generated1784540504";
import Generated1784605145 from "./generated/Generated1784605145";
import CommentLayer from "./comments/CommentLayer";
import "./styles.css";

const generatedPages: Record<string, React.ReactNode> = {
  "/generated-1784536714": <Generated1784536714 />,
  "/generated-1784537122": <Generated1784537122 />,
  "/generated-1784537459": <Generated1784537459 />,
  "/generated-1784537902": <Generated1784537902 />,
  "/generated-1784538152": <Generated1784538152 />,
  "/generated-1784540504": <Generated1784540504 />,
  "/generated-1784605145": <Generated1784605145 />,
};

const generatedPage = generatedPages[window.location.pathname];
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>{generatedPage ? <>{generatedPage}<CommentLayer /></> : <App />}</React.StrictMode>,
);
